import { render } from "./AlertErrorComponent.vue?vue&type=template&id=8c77f9b2"
import script from "./AlertErrorComponent.vue?vue&type=script&lang=js"
export * from "./AlertErrorComponent.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__